import { ReactNode } from "react"


export function AuthenticatedPlainLayout({ children }: { children: ReactNode }) {

  return (
    <div>
      {children}
    </div>
  )

}